export enum OpportunityTypeEnum {
    INDICATOR = "indicator",
    REPORT = "report",
}
